import * as Common from "../../commons/common"

export class SheetField{
  id: number
  kind: number
  page: number
  part1: string
  part2: string
  part3: string
  allot: number
  rim: number[]

  get name(): string{
    let rtn = "";
    if(this.kind == Common.SheetFieldKindEnum.TOTAL_SCORE){
      rtn = "得点";
    }else if(this.kind == Common.SheetFieldKindEnum.STUDENT_INFO){
      rtn = "生徒情報";
    }else if(this.kind == Common.SheetFieldKindEnum.PART1){
      rtn = `大問${this.part1}`;
    }else{
      if(this.part1 != null){
        rtn += this.part1;
      }
      if(this.part2 != null){
        rtn += ` ${this.part2}`
      }
      if(this.part3 != null){
        rtn += ` ${this.part3}`
      }
    }
    return rtn;
  }

  constructor(sheet_field: any){
    this.id = sheet_field.id;
    this.kind = sheet_field.kind;
    this.page = sheet_field.page;
    this.part1 = sheet_field.part1;
    this.part2 = sheet_field.part2;
    this.part3 = sheet_field.part3;
    this.allot = sheet_field.allot;
    this.rim = sheet_field.rim;
  }
}


export class FieldItem{
  sheetField: SheetField | null = null
  key: number = 0
  sortNo: number = 0
  x: number = 0
  y: number = 0
  width: number = 0
  height: number = 0
  isActive: boolean = false
}


export class PageItem{
  pageNo: number
  base64Image: string
  baseWidth: number
  baseHeight: number
  sheetFields: SheetField[] = new Array<SheetField>()
  fieldItems: FieldItem[] = new Array<FieldItem>()

  constructor(pageNo: number, base64Image: string, baseWidth: number, baseHeight: number){
    this.pageNo = pageNo;
    this.baseWidth = baseWidth;
    this.baseHeight = baseHeight;
    this.base64Image = base64Image;
  }
}

export class Pos {
  x: number
  y: number

  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}